import React from 'react';
import { GiftIcon } from 'lucide-react';
import { motion } from 'framer-motion';
type BonusCardProps = {
  number: number;
  title: string;
  description: string;
  imageUrl: string;
  delay?: number;
};
export function BonusCard({
  number,
  title,
  description,
  imageUrl,
  delay = 0
}: BonusCardProps) {
  return <motion.article initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.4,
    delay
  }} className="overflow-hidden rounded-2xl border border-orange-100 bg-white shadow-md" data-id="element-19">
      <div className="relative aspect-[16/8] overflow-hidden bg-orange-50" data-id="element-20">
        <img src={imageUrl} alt={`Bonus: ${title}`} className="h-full w-full object-cover" data-id="element-21" />
        <div className="absolute left-3 top-3 inline-flex items-center gap-1.5 rounded-full bg-slate-900 px-2.5 py-1 text-[10px] font-black uppercase tracking-wide text-yellow-300 shadow-sm" data-id="element-22">
          <GiftIcon className="h-3 w-3" data-id="element-23" />
          Bonus {number}
        </div>
      </div>
      <div className="p-4" data-id="element-24">
        <h3 className="text-base font-black leading-tight text-slate-900" data-id="element-25">
          {title}
        </h3>
        <p className="mt-1.5 text-sm leading-relaxed text-slate-600" data-id="element-26">
          {description}
        </p>
        <p className="mt-3 text-xs font-black uppercase tracking-wide text-pink-600" data-id="element-27">
          Incluido sin costo extra
        </p>
      </div>
    </motion.article>;
}